import React, { useState } from 'react';
import { router } from '@inertiajs/react';
import SignupLayout from './Layout.jsx';
import RadioCard from '../../components/RadioCard.jsx';
import { getCsrfToken } from '../../lib/csrf.js';

const primaryBtnClass = "w-full rounded-lg bg-indigo-600 px-5 py-2.5 text-sm/6 font-semibold text-white shadow-sm ring-1 ring-inset ring-indigo-600/20 transition duration-150 hover:bg-indigo-700 hover:shadow-md cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed";

export default function SignupIndex({ flow }) {
  const [buyerType, setBuyerType] = useState(flow === 'individual' ? 'self' : flow === 'group' ? 'staff' : '');
  const [submitting, setSubmitting] = useState(false);

  const handleContinue = () => {
    if (!buyerType || submitting) return;
    setSubmitting(true);
    const next = buyerType === 'self' ? '/signup/individual/buyer' : '/signup/group/buyer';
    const flowVal = buyerType === 'self' ? 'individual' : 'group';
    const csrf = getCsrfToken();
    fetch('/api/buy_draft/merge', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
      credentials: 'same-origin',
      body: JSON.stringify({ patch: { flow: flowVal } }),
    }).finally(() => router.visit(next));
  };

  return (
    <SignupLayout maxWidth="sm:max-w-md">
      <div className="space-y-4">
        <div className="text-center space-y-2">
          <h2 className="text-2xl/9 font-bold tracking-tight text-gray-900">Who's this training for?</h2>
          <p className="text-sm text-gray-500">We'll customize the next steps based on your answer.</p>
        </div>
        <fieldset className="space-y-3 mt-6">
          <RadioCard
            name="buyer_type" value="self" checked={buyerType === 'self'}
            onChange={() => setBuyerType('self')}
            label="For myself"
            description="I'm purchasing my own training"
          />
          <RadioCard
            name="buyer_type" value="staff" checked={buyerType === 'staff'}
            onChange={() => setBuyerType('staff')}
            label="For my staff"
            badge="Bulk discounts"
            badgeVariant="indigo"
            description="I'm managing training for one or more team members"
          />
        </fieldset>

        <p className="mt-4 text-center text-xs text-gray-500">
          <span className="mr-1">🔒</span>Takes about 60 seconds. No payment required to see pricing.
        </p>

        <button type="button" onClick={handleContinue} disabled={!buyerType || submitting} className={`mt-4 ${primaryBtnClass}`}>
          Continue
        </button>
      </div>
    </SignupLayout>
  );
}
